export default __webpack_public_path__ + "static/media/Doctor.6303956b.svg";